import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import LottieFileFolder from "../../animations/LottieFileFolder";
import {
  getRecordedServices,
  getServiceItems,
  getBedDayServices,
  billingRules,
} from "../services/soar";
import ExpandDiv from "./ExpandDiv";
import Input from "./Input";
import Select from "./Select";

function BedDaysTab({
  contactID,
  clientProgram,
  modalities,
  payors,
  birthdate,
}) {
  const [excludedServiceItemIds, setExcludedServiceItemIds] = useState([]);
  const [bedDays, setBedDays] = useState([]);
  const [rules, setRules] = useState([]);
  const [retrievedPayors, setRetrievedPayors] = useState([]);
  const [billingForms, setBillingForms] = useState([]);
  const [selectedBillingForm, setSelectedBillingForm] = useState(null);
  const [data, setData] = useState({});
  const [selectedRule, setSelectedRule] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   getServiceItems().then((response) => {
  //     const excluded = response
  //       .filter((serviceItem) => serviceItem.ccx_needs_bed["#text"] === "1")
  //       .map((serviceItem) => serviceItem.ccx_service_itemid);

  //     setExcludedServiceItemIds(excluded);
  //   });
  // }, []);

  useEffect(() => {
    setLoaded(false);

    getBedDayServices(contactID).then((response) => {
      const bds = response.resultset.result;
      console.log("Bed Days", bds);

      // Sort the bds array on ccx_starttime with the most recent first
      bds.sort(
        (a, b) =>
          new Date(b.ccx_starttime["@date"]) -
          new Date(a.ccx_starttime["@date"])
      );

      setBedDays(bds);
      setLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (payors.length > 0) {
      console.log("Payors", payors);
      LoadRules();
    }
  }, [payors]);

  const LoadRules = () => {
    //Need to find valid Payors for time frame
    //Check for single modality for time frame
    // const modality = modalities.filter((m) => m.ccx_enddate === undefined)[0]
    //   ?.ccx_caremodality["@name"];

    // console.log("Modality", modality);

    const payorPromises = payors.map((payor) => {
      const body = {
        // age: calculateAge(),
        payor: payor.ccx_payor["@name"],
        grouppayor: payor.ccx_groupname,
      };

      return billingRules(body);
    });

    Promise.all(payorPromises).then((responses) => {
      console.log("Payor Rules", responses);
      const payorRules = responses.map((response) => response.data).flat();
      // .filter((r) => r.Id !== null);
      console.log("Filtered Payor Rules", payorRules);
      setRules(payorRules);
      setRetrievedPayors([...new Set(payorRules.map((item) => item.Payor))]);
      setBillingForms(
        [...new Set(payorRules.map((item) => item.BillingForm))].map((bf) => ({
          _id: bf,
          name: bf,
        }))
      );
    });
  };

  const handleChange = ({ currentTarget: input }) => {
    const newData = { ...data };
    newData[input.name] = input.value;
    setData(newData);
  };

  const quickSet = () => {
    let newData = { ...data };
    newData.startDate = "2023-06-01";
    newData.endDate = "2023-07-31";
    setData(newData);
  };

  const FilterBedDays = () => {
    let filtered = [...bedDays];
    if (data.startDate && data.endDate) {
      filtered = filtered.filter((bedDay) => {
        const startTime = new Date(bedDay.ccx_starttime["@date"]);
        const endDatePlusOneDay = new Date(
          new Date(data.endDate).getTime() + 86400000
        );
        return (
          startTime >= new Date(data.startDate) &&
          startTime <= endDatePlusOneDay
        );
      });
    }
    filtered.forEach((bd) => {
      bd.rule = calculateRate(
        bd.ccx_serviceitem["@name"],
        bd.ccx_servicestatuslookup["@name"],
        bd.ccx_starttime["@date"],
        payors.filter(
          (p) =>
            retrievedPayors.includes(p.ccx_payor["@name"]) &&
            new Date(bd.ccx_starttime["@date"]) >=
              new Date(p.ccx_effdate["@date"]) &&
            (!p.ccx_expdate ||
              new Date(bd.ccx_starttime["@date"]) <=
                new Date(p.ccx_expdate["@date"]))
        )[0],
        modalities.filter(
          (m) =>
            new Date(bd.ccx_starttime["@date"]) >=
              new Date(m.ccx_startdate["@date"]) &&
            (!m.ccx_enddate ||
              new Date(bd.ccx_starttime["@date"]) <=
                new Date(m.ccx_enddate["@date"]))
        )[0]?.ccx_caremodality["@name"],
        calculateAge(bd.ccx_starttime["@date"])
      );
    });
    return filtered;
  };

  const calculateAge = (d) => {
    if (!birthdate) {
      return null;
    }

    const today = new Date(d);
    const birthDate = new Date(birthdate["@date"]);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const calculateRate = (item, status, serviceTime, payor, modality, age) => {
    if (!rules || rules.length === 0) {
      return null;
    }

    const matchingRules = rules.filter(
      (r) =>
        r.Payor === payor?.ccx_payor["@name"] &&
        r.GroupPayor.replaceAll("&", "") ===
          payor?.ccx_groupname.replaceAll("&", "") &&
        (r.Modality === "include all" ||
          r.Modality === "ALLBillingModalities" ||
          (r.TreatmentModality &&
            JSON.parse(r.TreatmentModality).data.filter(
              (tm) => tm.treatment.modality === modality //need to compare dates
            ).length > 0)) &&
        r.ServiceItem === item &&
        r.ServiceStatus.replaceAll("Include ", "")
          .replaceAll("ATTENDED-DEFAULT", "Occupied")
          .toLowerCase() ===
          status.replaceAll("Attended", "Occupied").toLowerCase() &&
        age >= r.AgeMin &&
        age < r.AgeMax &&
        new Date(serviceTime) >= new Date(r.EffectiveDate) &&
        (r.ExpirationDate === null ||
          new Date(serviceTime) < new Date(r.ExpirationDate))
    );

    switch (matchingRules.length) {
      case 1:
        return {
          rate: matchingRules[0].Rate,
          ruleId: matchingRules[0].RuleId,
          message: "single matching rule",
          payor: matchingRules[0].Payor,
        };
      case 0:
        return {
          rate: null,
          ruleId: null,
          message: (
            <>
              <div className="fw-bold text-danger">0 Rules Found</div>
              <div>{payor?.ccx_payor["@name"]}</div>
              <div>{payor?.ccx_groupname}</div>
              <div>{modality}</div>
              <div>{item}</div>
              <div>{status}</div>
              <div>{serviceTime}</div>
              <div>{age}</div>
              <i
                className="fas fa-magnifying-glass"
                onClick={() =>
                  window.open(
                    `http://${window.location.host}/CRE?Payor=${payor?.ccx_payor["@name"]}&GroupName=${payor?.ccx_groupname}&ServiceItem=${item}&Age=${age}`
                  )
                }
              ></i>
            </>
          ),
        };
      default:
        return {
          rate: null,
          ruleId: null,
          message: (
            <>
              <div className="fw-bold text-danger">Multiple Rules Found</div>
              <div>{matchingRules.map((r) => `${r.RuleId}, `)}</div>
              <div>{payor?.ccx_payor["@name"]}</div>
              <div>{payor?.ccx_groupname}</div>
              <div>{modality}</div>
              <div>{item}</div>
              <div>{status}</div>
              <div>{serviceTime}</div>
              <div>{age}</div>
              <i
                className="fas fa-magnifying-glass"
                onClick={() =>
                  window.open(
                    `http://localhost:3000/CRE?Payor=${payor?.ccx_payor["@name"]}&GroupName=${payor?.ccx_groupname}&ServiceItem=${item}&Age=${age}`
                  )
                }
              ></i>
            </>
          ),
        };
    }
  };

  const ExportBilling = () => {
    navigate("/RC/Invoice", {
      state: {
        billingRules: rules,
        bedDays: FilterBedDays(),
        data: data,
        payors: payors,
        clientId: contactID,
      },
    });
  };

  return (
    <div>
      <Modal
        show={selectedRule !== null}
        animation={false}
        onHide={() => {
          setSelectedRule(null);
        }}
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>{`Census Rule ${selectedRule}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {rules
            .filter((r) => r.RuleId === selectedRule)
            .map((r, index) => {
              return (
                <div key={`Rule${r.RuleId}-${index}`}>
                  <div className="row">
                    <div className="col">Payor</div>
                    <div className="col">{r.Payor}</div>
                  </div>
                  <div className="row">
                    <div className="col">Group Payor</div>
                    <div className="col">{r.GroupPayor}</div>
                  </div>
                  <div className="row">
                    <div className="col">Service Item</div>
                    <div className="col">{r.ServiceItem}</div>
                  </div>
                  <div className="row">
                    <div className="col">Service Status</div>
                    <div className="col">{r.ServiceStatus}</div>
                  </div>
                  <div className="row">
                    <div className="col">Modality</div>
                    <div className="col">{r.Modality}</div>
                  </div>
                  <div className="row">
                    <div className="col">Rate</div>
                    <div className="col">{r.Rate}</div>
                  </div>
                  <div className="row">
                    <div className="col">Expected</div>
                    <div className="col">{r.Expected}</div>
                  </div>
                  <div className="row">
                    <div className="col">Effective Date</div>
                    <div className="col">{r.EffectiveDate}</div>
                  </div>
                  <div className="row">
                    <div className="col">Expiration Date</div>
                    <div className="col">{r.ExpirationDate}</div>
                  </div>
                  <div className="row">
                    <div className="col">Age Min</div>
                    <div className="col">{r.AgeMin}</div>
                  </div>
                  <div className="row">
                    <div className="col">Age Max</div>
                    <div className="col">{r.AgeMax}</div>
                  </div>
                  <div className="row">
                    <div className="col">Billing Form</div>
                    <div className="col">{r.BillingForm}</div>
                  </div>
                  <div className="row">
                    <div className="col">Price Per</div>
                    <div className="col">{r.PricePer}</div>
                  </div>
                  <div className="row">
                    <div className="col">Revenue Booked As</div>
                    <div className="col">{r.RevenuBookedAs}</div>
                  </div>
                  <div className="row">
                    <div className="col">Series Billing</div>
                    <div className="col">{r.SeriesBilling}</div>
                  </div>
                  <div className="row">
                    <div className="col">Round</div>
                    <div className="col">{r.Round}</div>
                  </div>
                  <div className="row">
                    <div className="col">Code</div>
                    <div className="col">{r.Code}</div>
                  </div>
                  <div className="row">
                    <div className="col">Contract ID</div>
                    <div className="col">{r.ContractId}</div>
                  </div>
                  <div className="row">
                    <div className="col">Full Name</div>
                    <div className="col">{r.FullName3}</div>
                  </div>
                </div>
              );
            })}
        </Modal.Body>
      </Modal>
      <ExpandDiv className="mb-4" title="Rules">
        {rules.map((rule, index) => {
          return (
            <div key={`rules${index}`} className="border p-2 m-1 bg-info">
              <div className="row">
                <div className="col-2">{`${rule.Payor}`}</div>
                <div className="col-2">{`${rule.GroupPayor}`}</div>
                <div className="col-2">{`${rule.ServiceItem}`}</div>
                <div className="col-2">{`${rule.ServiceStatus}`}</div>
                <div className="col-2">{`${rule.Modality}`}</div>
                <div className="col-1">{`${rule.RuleId}`}</div>
                <div className="col-1 fw-bold h5">{`$${rule.Rate}`}</div>
              </div>
              <div className="row">
                <div className="col-2">{`${rule.EffectiveDate}`}</div>
                <div className="col-2">{`${rule.ExpirationDate}`}</div>
              </div>
            </div>
          );
        })}
      </ExpandDiv>
      <div className="h5">Census Days</div>
      {loaded === true ? (
        <>
          <div className="row">
            <div className="col-3">
              <Input
                label="Start Date"
                name="startDate"
                type="date"
                value={data.startDate}
                onChange={handleChange}
              />
              <i
                className="fa-regular fa-face-smile text-success fa-lg"
                onClick={() => quickSet()}
              ></i>
            </div>
            <div className="col-3">
              <Input
                label="End Date"
                name="endDate"
                type="date"
                value={data.endDate}
                onChange={handleChange}
              />
            </div>
            <div className="col-2">
              Census Count:
              <div className="h5 fw-bold">
                {FilterBedDays().filter((bd) => bd.rule.rate !== null).length}
              </div>
            </div>
            <div className="col-1">
              Errors:
              <div className="h5 fw-bold text-danger">
                {FilterBedDays().filter((bd) => bd.rule.rate === null).length}
              </div>
            </div>
            <div className="col">
              Total:
              <div className="h5 fw-bold">
                $
                {FilterBedDays()
                  .reduce(
                    (total, bd) =>
                      total + (bd?.rule?.rate !== null ? bd.rule.rate : 0),
                    0
                  )
                  .toLocaleString()}
              </div>
              <div className="row">
                <div className="col-10">
                  <Select
                    label="Billing Form"
                    name="billingForm"
                    value={selectedBillingForm || ""}
                    onChange={(e) => setSelectedBillingForm(e.target.value)}
                    options={billingForms}
                  />
                </div>
                <div className="col-2">
                  <i
                    className="fas fa-file-pdf fa-2x text-success pt-4 mt-2"
                    onClick={() => ExportBilling()}
                  />
                </div>
              </div>
            </div>
          </div>
          {FilterBedDays().map((bd) => {
            return (
              <div
                key={`bd${bd.ccx_recorded_serviceid}`}
                className="row border p-2 m-1 bg-light"
              >
                <div className="col-1">{`${bd.ccx_starttime["@date"]}`}</div>
                <div className="col-4">{`${bd.ccx_name}`}</div>
                <div className="col-2">{`${bd.ccx_serviceitem["@name"]}`}</div>
                <div className="col-1">{`${bd.ccx_servicestatuslookup["@name"]}`}</div>
                <div className="col-1 fw-bold">{`${
                  bd.rule.rate !== null ? `$${bd.rule.rate}` : ""
                }`}</div>
                <div className="col-3">
                  {bd.rule.ruleId ? (
                    <button
                      className="btn btn-info"
                      onClick={() => setSelectedRule(bd.rule.ruleId)}
                    >
                      Rule ID: {bd.rule.ruleId}
                    </button>
                  ) : (
                    bd.rule.message
                  )}
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <div className="row col-2 d-flex justify-content-center align-items-center">
          <LottieFileFolder />
        </div>
      )}
    </div>
  );
}

export default BedDaysTab;
